import type { ReactNode } from 'react';
import React from 'react';
import classnames from 'clsx';

import { formatClassNames } from '@wix/editor-elements-common-utils';
import styles from '../button.scss';
import semanticClassNames from '../../../../RichTextBox.semanticClassNames';

export type AlignButtonProps = {
  onClick?: React.MouseEventHandler<HTMLOrSVGElement>;
  selected?: boolean;
  children: ReactNode;
  dataTestId?: string;
  tabIndex?: number;
};

export default React.forwardRef(
  (props: AlignButtonProps, ref: React.Ref<SVGSVGElement>) => {
    const { onClick, selected, children, dataTestId, tabIndex } = props;
    return (
      <svg
        tabIndex={tabIndex}
        onClick={onClick}
        ref={ref}
        viewBox="0 0 19 19"
        className={classnames(
          styles.buttonContent,
          formatClassNames(semanticClassNames.icons),
          selected && styles.buttonContentSelected,
        )}
        role="menuitemradio"
        data-testid={dataTestId}
        aria-checked={selected}
      >
        {children}
      </svg>
    );
  },
);
